import React from 'react';
import { CornerStyle } from 'context/ThemeContext/ThemeContext';
import { useThemeContext } from 'context/ThemeContext/ThemeContext';
import { ReactComponent as Checkmark } from 'assets/icons/svg/checkbox-checkmark.svg';

type ConsentCheckProps = {
  text?: string;
  error?: boolean;
  styles?: string;
  consentCheck: boolean;
  toggleConsentCheck: React.Dispatch<React.SetStateAction<boolean>>;
};

const ConsentCheck: React.FC<ConsentCheckProps> = ({
  text,
  error,
  styles,
  consentCheck,
  toggleConsentCheck,
}) => {
  const { inputStyle } = useThemeContext();

  const getCornerStyle = () => {
    switch (inputStyle) {
      case CornerStyle.FULL_ROUND:
        return 'rounded-[26px]';
      case CornerStyle.ROUNDED_CORNERS:
        return 'rounded-sm1';
      case CornerStyle.SQUARE_CORNERS:
        return 'rounded-none';
      default:
        return 'rounded-[26px]';
    }
  };

  return (
    <button
      type='button'
      onClick={() => toggleConsentCheck(!consentCheck)}
      className={`relative w-full flex flex-row items-center gap-3 py-1.5 pl-3 pr-7 mb-1 bg-lightgray cursor-pointer border-2 border-solid 
        ${error && !consentCheck ? 'border-warning' : 'border-lightgray'} 
        ${getCornerStyle()} ${styles}
      `}
    >
      <div
        className={`w-[18px] h-[18px] m-[3px] flex items-center justify-center aspect-square rounded-sm ${
          consentCheck ? 'border-none' : 'border-2 border-solid'
        }`}
      >
        {consentCheck ? <Checkmark /> : null}
      </div>
      {text && (
        <div
          dangerouslySetInnerHTML={{ __html: text }}
          className='text-xxs text-black font-medium text-left leading-[15px] [&_a]:underline'
        />
      )}
    </button>
  );
};

export default ConsentCheck;
